import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { UserRole } from '../../types/UserRole';
import { Notice, OnboardingPage } from '../../ui';

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const CycleCreationResult = (props) => {
  if (props.user.role !== UserRole.Customer) {
    return <Redirect to="/" />;
  }

  const url = new URL(window.location.href);
  const searchParms = new URLSearchParams(url.search);
  const status = searchParms.get('status');

  return (
    <OnboardingPage title={status === 'success' ? 'Cycle created successfully!' : status === 'fail' ? 'Unable to create the cycle' : ''}>
      {status === 'success' && (
        <Notice severity="success" title="Congratulations! Your cycle was created successfully.">
          You can track its status from your account page.
        </Notice>
      )}

      {status === 'fail' && (
        <Notice severity="error">Please try again later or contact customer support</Notice>
      )}

      {status !== 'success' && status !== 'fail' && <Typography>...</Typography>}
    </OnboardingPage>
  );
};

export default connect(mapStateToProps)(CycleCreationResult);
